import { render, staticRenderFns } from "./loginDistributor.vue?vue&type=template&id=094544c2&"
import script from "./loginDistributor.vue?vue&type=script&lang=js&"
export * from "./loginDistributor.vue?vue&type=script&lang=js&"
import style0 from "./loginDistributor.vue?vue&type=style&index=0&id=094544c2&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports